export default {"src":"/_next/static/media/first_gen.ed431d84.gif","height":1297,"width":600,"blurWidth":0,"blurHeight":0};